import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';

Swiper.use([FreeMode]);

export default function () {
	// Initiate the swiper
	const imageCarousels = document.querySelectorAll('.js-image-carousel');
	if (!imageCarousels.length) return;

	const swiper = new Swiper('.js-image-carousel', {
		freeMode: {
			enabled: true, // Whether the free mode is enabled
			minimumVelocity: 0.02, // Minimum touchmove-velocity required to trigger free mode momentum
			momentum: true, // If enabled, then slide will keep moving for a while after you release it
			momentumBounce: true, // Set to false if you want to disable momentum bounce in free mode
			momentumBounceRatio: 2, // Higher value produces larger momentum bounce effect
			momentumRatio: 2, // Higher value produces larger momentum distance after you release slider
			momentumVelocityRatio: 2, // Higher value produces larger momentum velocity after you release slider
			sticky: false, // Set to enabled to enable snap to slides positions in free mode
		},
		grabCursor: true,
		slidesPerView: 'auto',
	});
}
